<template>
  <v-img
    src="~@/assets/coach-profile/coach-profile-banner.jpg"
    lazy-src="~@/assets/coach-profile/coach-profile-banner-thumb.jpg"
    :aspect-ratio="100"
  >
    <v-container
      class="white--text align-stretch top pa-0"
      fluid
    >
      <!-- Logo row -->
      <v-row
        align="center"
        class="px-10 py-8"
      >
        <v-col cols="6">
          <v-img
            src="~@/assets/branding/gcg_logo.png"
            height="25"
            contain
            position="left center"
          />
        </v-col>
        <v-col
          class="text-right"
          cols="6"
        >
          <v-img
            src="~@/assets/branding/gcg_slogan.png"
            height="30"
            contain
            position="right center"
          />
        </v-col>
      </v-row>

      <!-- Coach main row -->
      <div
        class="px-10 pt-8 pb-12 d-flex align-center"
      >
        <div
          class="d-flex align-start flex-column"
          style="width: 100%;"
        >
          <div class="display-2 align-self-start mb-auto mt-4">
            <v-skeleton-loader
              :loading="loading"
              width="250"
              type="heading"
            >
              <div
                class="brandFont font-weight-bold"
                style="font-size: 1.75rem;"
              >
                {{ coach.first_name }} {{ coach.last_name }}
              </div>

              <div
                v-if="formattedCertification && formattedCertification.length"
                class="body-1 mt-2 font-weight-bold"
              >
                <span
                  class="brandFont"
                  style="line-height: 1.5rem;"
                >
                  {{ formattedCertification }}
                </span>
              </div>
            </v-skeleton-loader>
          </div>

          <div
            v-if="coach.profile.title"
            class="title mt-8 mb-3"
          >
            <span class="body-1 brandFont font-weight-bold">
              {{ coach.profile.title }}
            </span>
          </div>
        </div>

        <div class="d-flex justify-end ml-12">
          <v-skeleton-loader
            id="coachProfileAvatar"
            :loading="loading"
            width="175"
            height="175"
            type="avatar"
          >
            <v-avatar
              size="175"
              :color="!coach.profile_image ? 'primary lighten-1' : ''"
            >
              <img
                v-if="coach.profile_image"
                :src="coach.profile_image"
                alt="Profile"
              />

              <span
                v-else
                class="white--text display-2"
              >
                <span class="brandFont">{{ initials }}</span>
              </span>
            </v-avatar>
          </v-skeleton-loader>
        </div>
      </div>
    </v-container>
  </v-img>
</template>

<script>
export default {
  name: 'Section1',

  props: {
    coach: {
      type: Object,
      default: null,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    initials() {
      if (!this.coach.first_name && !this.coach.last_name) return 'X X';
      let init1 = '';
      let init2 = '';
      if (this.coach.first_name) {
        init1 = this.coach.first_name[0].substring(0, 1).toUpperCase();
      }
      if (this.coach.last_name) {
        init2 = this.coach.last_name[0].substring(0, 1).toUpperCase();
      }
      return `${init1} ${init2}`;
    },

    formattedCertification() {
      if (!this.coach || !this.coach.profile.languages) return [];
      return this.coach.certifications.map((el) => el.certification.name).join(', ');
    },
  },
};
</script>
